import { z } from 'zod';
import { ClientRequestConst } from '@axiom/const';
import { SchemaEmail, SchemaTimestamp, ZodArrayToEnum } from '@axiom/types';

import { ZodCandidateOpportunityCandidateStatuses } from './candidate-opportunities-candidate-statuses';

export const ClientRequestRejectionLossCodes = Object.values(
  ClientRequestConst.AfcRejectionLossCodes
);

export const CalendarManualInterviewRequestSchema = z.object({
  adhocEmail: SchemaEmail.nullable(),
  adhocFirstName: z.string().nullable(),
  adhocLastName: z.string().nullable(),
  availabilityNote: z.string().nullable(),
  candidateId: z.string().uuid(),
  clientRequestId: z.string().uuid(),
  contactId: z.string().uuid(),
  createdAt: SchemaTimestamp,
  id: z.string().uuid(),
  updatedAt: SchemaTimestamp,
});

export type CalendarManualInterviewRequest = z.infer<
  typeof CalendarManualInterviewRequestSchema
>;

export const ClientRequestSchema = z.object({
  candidateId: z.string().uuid(),
  candidateOpportunityStatus: ZodCandidateOpportunityCandidateStatuses,
  calendarManualInterviewRequests: z.array(
    CalendarManualInterviewRequestSchema
  ),
  clientUserId: z.string().uuid(),
  id: z.string().uuid(),
  notes: z.string().nullable(),
  opportunityId: z.string().uuid(),
  rejectionLossCodes: z
    .array(z.enum(ZodArrayToEnum(ClientRequestRejectionLossCodes)))
    .nullable(),
  submissionId: z.string().uuid(),
});

export type ClientRequest = z.infer<typeof ClientRequestSchema>;
